import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = API_URLS.ACCREDITED;

// GET /api/v3/accredited — sem parâmetros, lista todos os credenciados.
async function fetchAccredited() {
  try {
    let response = await api.get(basePath);
    let treated = errorHandling.handleResponse(
      response,
      "accreditedService.fetchAccredited"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "accreditedService.fetchAccredited");
    return null;
  }
}

export const accreditedService = {
  fetchAccredited,
};
